import { ReleaseComponentProps } from '../../typescriptHelpers';
import * as React from 'react';
import List from 'antd/lib/list';
import { descriptionForCapability } from '../../helpers';
import { IntegrationCapability } from '../../types';
import {
    CapabilityIntegrationsListItem,
    ConnectIntegrationsBannerWrapper,
    DefaultDocsLinkNode,
} from '../ConnectIntegrationsBanner';

const FeatureFlagsIntegrationBanner: React.FC<ReleaseComponentProps> = (props) => {
    return (
        <ConnectIntegrationsBannerWrapper>
            <List
                itemLayout="vertical"
                dataSource={[IntegrationCapability.FeatureFlagging]}
                renderItem={(item) => {
                    const description = descriptionForCapability(IntegrationCapability.FeatureFlagging);
                    const docsNodeForCapability = (
                        <DefaultDocsLinkNode capability={IntegrationCapability.FeatureFlagging} />
                    );
                    return (
                        <CapabilityIntegrationsListItem
                            appId={props.appId}
                            orgId={props.orgId}
                            capability={item}
                            description={description}
                            docsNodeForCapability={docsNodeForCapability}
                        />
                    );
                }}
            />
        </ConnectIntegrationsBannerWrapper>
    );
};

export default FeatureFlagsIntegrationBanner;
